import MiniGameImages from "../MiniGameImages";
import PersonalityQuizOptionModel from "./PersonalityQuizOptionModel";

export default class PersonalityQuizQuestionModel {
  public questionId: number = null;
  public question: string = null;
  public images: MiniGameImages | null = null;
  public explanation: string | null = null;
  public options: PersonalityQuizOptionModel[] = [];
}
